/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { EyeOffIcon16Light } from './EyeOffIcon16Light';
import { EyeOffIcon16Regular } from './EyeOffIcon16Regular';
import { EyeOffIcon16Solid } from './EyeOffIcon16Solid';
import { EyeOffIcon20Light } from './EyeOffIcon20Light';
import { EyeOffIcon20Regular } from './EyeOffIcon20Regular';
import { EyeOffIcon20Solid } from './EyeOffIcon20Solid';
import { EyeOffIcon24Regular } from './EyeOffIcon24Regular';
import { EyeOffIcon24Solid } from './EyeOffIcon24Solid';
import { EyeOffIcon32Regular } from './EyeOffIcon32Regular';
import { EyeOffIcon64Regular } from './EyeOffIcon64Regular';
var sizes = {
    16: {
        light: EyeOffIcon16Light,
        regular: EyeOffIcon16Regular,
        solid: EyeOffIcon16Solid,
    },
    20: {
        light: EyeOffIcon20Light,
        regular: EyeOffIcon20Regular,
        solid: EyeOffIcon20Solid,
    },
    24: {
        regular: EyeOffIcon24Regular,
        solid: EyeOffIcon24Solid,
    },
    32: {
        regular: EyeOffIcon32Regular,
    },
    64: {
        regular: EyeOffIcon64Regular,
    },
};
export var EyeOffIcon = forwardRef('EyeOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
